import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MiniLoaderComponent } from './mini-loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [MiniLoaderComponent],
  imports: [CommonModule, MatProgressSpinnerModule],
  exports: [MiniLoaderComponent],
})
export class MiniLoaderModule {}
